import { ArrowRight, Wallet } from 'lucide-react';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';
import OutsideNorthAmerica from '@/components/outside-north-america';
import { Button, Card, IconTile, Section } from '@/components/ui';
import { up } from '@/themes';

const Panel = styled(Card)`
  align-items: flex-start;
  gap: 16px;

  ${up.sm} {
    align-items: center;
    flex-direction: row;
  }
`;

const Copy = styled.p`
  color: var(--card-foreground);
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
  text-wrap: pretty;
`;

// Its own component so the copy is only read once the gate has opened.
const Teaser = ({ className }) => {
  const t = useTranslations('payTeaser');

  return (
    <Section id="stablecoins-teaser" $spacing="compact" className={className}>
      <Panel $padding="default">
        <IconTile>
          <Wallet size={20} strokeWidth={1.75} />
        </IconTile>
        <Copy>{t('text')}</Copy>
        <Button $variant="outline" $size="lg" href="/stablecoins">
          {t('link')}
          <ArrowRight size={16} strokeWidth={1.75} />
        </Button>
      </Panel>
    </Section>
  );
};

/**
 * One-line pointer to /stablecoins for visitors outside North America.
 *
 * Self-contained and gated: it renders nothing on the server, while the
 * location is loading, in the United States and Canada, and when the location
 * is unknown. So the link never reaches server HTML. No props required.
 *
 *   <StablecoinsTeaser />
 */
const StablecoinsTeaser = ({ className }) => (
  <OutsideNorthAmerica>
    <Teaser className={className} />
  </OutsideNorthAmerica>
);

export default StablecoinsTeaser;
